import React, { ChangeEventHandler } from "react";
import styles from './MeritoRadioButton.module.scss'
import { OverlayTrigger } from "react-bootstrap";
import { RenderSideBarTooltip, RenderTooltip } from "../../../../components/common/RenderTooltip";
import { SidebarTooltip } from "../../../ReportDetails/Components/ReportTabs/TabsContent/reportDataPiece/tooltip/Tooltip.styled";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

type Props = {
    label: string;
    radioLabels: {
        label: string;
        value: string;
        disabledState?: boolean;
        disabledMessage?: string;
    }[],
    name: string;
    onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
    error: any,
    touched?: boolean,
    value: string;
    fieldContainerStyle?: React.CSSProperties,
    size?: "md" | "md2",
    isLabelBold?: boolean
}

const radioSizeStyles = {
    md: {
        fontFamily: "Work Sans",
        fontSize: "0.6875rem",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "0.875rem",
        letterSpacing: "0.00688rem",
    },
    md2: {
        fontFamily: "Work Sans",
        fontSize: "0.875rem",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "1.125rem", /* 128.571% */
        letterSpacing: "0.00875rem"
    }
}


const MeritoRadioButton = ({ label, radioLabels, name, onChange: handleChange, error, value, fieldContainerStyle = {}, size = "md", isLabelBold = false, touched = false, ...restProps }: Props) => {
    // console.log("radioBtnValue", value)

    return (
        <div id={`${name}`} style={fieldContainerStyle} className={`${styles.fieldContainer} ${styles[size]}`}>
            {label && <div className={`${styles.label} ${isLabelBold ? styles.isBold : ''}`}>{label}</div>}
            <div className={styles.radioRootContainer}>
                <FormControl>
                    <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={value}
                        onChange={handleChange}
                        {...restProps}
                    >
                        {radioLabels.map((item, index) => {
                            const radioInput = (
                                // <label className={`${styles.radioContainer} ${item.disabledState ? styles.disabled : ''}`}>
                                //     {item.label}
                                //     <input disabled={item.disabledState} {...restProps} onChange={(e) => {
                                //         // console.log("onChange", e.target.value)
                                //         // if (!item.disabledState) {
                                //         handleChange(e);
                                //         // }
                                //     }} value={item.value} type="radio" name={name} checked={value == item.value} />
                                //     <span className={`${styles.check} ${item.disabledState ? styles.disabled : ''}`}></span>
                                // </label>
                                <FormControlLabel
                                    style={{ marginRight: "1.5rem" }}
                                    sx={{
                                        '&.MuiFormControlLabel-root': {
                                            marginRight: "1.5rem",

                                            '&:hover': {
                                                '&.Mui-disabled': {
                                                    cursor: "not-allowed"
                                                }
                                            }
                                        },
                                        '& .MuiFormControlLabel-label': {
                                            ...radioSizeStyles[size]
                                        }
                                    }} value={item.value} control={<Radio disabled={item.disabledState} size="small" sx={{
                                        color: "#D4D4D4",
                                        '&.Mui-checked': {
                                            color: "#100828",
                                        },
                                        '&.Mui-disabled': {
                                            opacity: '0.6'
                                        },
                                        '&.MuiRadio-root': {
                                            padding: '0rem 0.5rem'
                                        }
                                    }} />} label={item.label} />
                            )
                            return (
                                <React.Fragment key={index}>
                                    {item.disabledState && item.disabledMessage ? (
                                        <OverlayTrigger
                                            // show={}

                                            placement="right"
                                            trigger={"hover"}
                                            delay={{ show: 100, hide: 100 }}
                                            overlay={(props) =>
                                                RenderSideBarTooltip(
                                                    { ...props },
                                                    item.disabledMessage ? item.disabledMessage : '',
                                                    "left"
                                                )
                                            }
                                        >
                                            {radioInput}
                                        </OverlayTrigger>
                                    ) : (
                                        <>
                                            {radioInput}
                                        </>
                                    )}
                                </React.Fragment>
                            )
                        })}
                    </RadioGroup>

                </FormControl>

            </div>
            {error && touched ? <div className={styles.errorText}>
                {error}
            </div> : null}
        </div>
    );
}

export default MeritoRadioButton